module.exports = __webpack_public_path__ + "static/media/ic_cellar.4c91bdfd.svg";